import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

export interface OperationIsReadyToStartOutput {
    isReady: boolean
}

export const useOperationIsReadyToStart = ({
    operationId
}: {
    operationId?: string
}) => {
    const { token } = useAuth()
    const endpoint = m2mCleaning_cleanerV3.isReadyToStartCleaning

    return useAuthBearerFetch<OperationIsReadyToStartOutput>(
        token,
        operationId ? endpoint({ cleaningId: operationId }) : null,
        {
            method: endpoint.method
        }
    )
}
